import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../api';
import { AuthContext } from '../App';

export default function Sidebar() {
  const { user } = useContext(AuthContext);
  const [channels, setChannels] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user) return;
    api.following().then(setChannels).catch(() => {});
    const interval = setInterval(() => {
      api.following().then(setChannels).catch(() => {});
    }, 30000);
    return () => clearInterval(interval);
  }, [user]);

  if (!user || channels.length === 0) return null;

  const liveChannels = channels.filter(c => c.is_live);
  const offlineChannels = channels.filter(c => !c.is_live);

  return (
    <div className={`sidebar ${collapsed ? 'sidebar-collapsed' : ''}`}>
      <div className="sidebar-header">
        {!collapsed && <span className="sidebar-title">Following</span>}
        <button
          className="sidebar-toggle"
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? 'Expand' : 'Collapse'}
        >
          {collapsed ? '»' : '«'}
        </button>
      </div>

      <div className="sidebar-channels">
        {liveChannels.map(ch => (
          <div
            key={ch.username}
            className={`sidebar-channel ${location.pathname.includes(ch.username) ? 'active' : ''}`}
            onClick={() => navigate(`/${ch.username}/watch`)}
            title={collapsed ? `${ch.display_name || ch.username} (LIVE)` : ''}
          >
            <div className="sidebar-avatar">
              {ch.avatar_url
                ? <img src={ch.avatar_url} alt="" />
                : <span>{(ch.display_name || ch.username).charAt(0).toUpperCase()}</span>
              }
              <span className="sidebar-live-dot" />
            </div>
            {!collapsed && (
              <div className="sidebar-info">
                <div className="sidebar-name">{ch.display_name || ch.username}</div>
                <div className="sidebar-category">{ch.category}</div>
              </div>
            )}
            {!collapsed && <span className="sidebar-live-badge">LIVE</span>}
          </div>
        ))}

        {offlineChannels.length > 0 && !collapsed && (
          <div className="sidebar-divider-label">Offline</div>
        )}
        {offlineChannels.map(ch => (
          <div
            key={ch.username}
            className={`sidebar-channel offline ${location.pathname.includes(ch.username) ? 'active' : ''}`}
            onClick={() => navigate(`/${ch.username}`)}
            title={collapsed ? (ch.display_name || ch.username) : ''}
          >
            <div className="sidebar-avatar">
              {ch.avatar_url
                ? <img src={ch.avatar_url} alt="" />
                : <span>{(ch.display_name || ch.username).charAt(0).toUpperCase()}</span>
              }
            </div>
            {!collapsed && (
              <div className="sidebar-info">
                <div className="sidebar-name">{ch.display_name || ch.username}</div>
                <div className="sidebar-category">{ch.category}</div>
              </div>
            )}
          </div>
        ))}
      </div>

      {!collapsed && (
        <div className="sidebar-footer" onClick={() => navigate('/following')}>
          Show All ({channels.length})
        </div>
      )}
    </div>
  );
}
